module.exports = __webpack_public_path__ + "static/media/sf-test-8.5ad01ad8.mp3";